import React, { FunctionComponent, useEffect, useState } from 'react';
import Styled from './Admin.styled';

import { AiOutlineMenu } from 'react-icons/ai';
import AdminBarraLateral from './components/barraLateral/AdminBarraLateral';
import AdminContent from './components/AdminContent';
import AdminProvider from './context/AdminProvider';
import { MobileMaxWidth } from 'constants/Dimensions';
import { ToasterDefault } from 'components/Toaster';
import DynamicHeader from 'components/dynamic_header/DynamicHeader';

export interface IAdmin {}

const isMobile = () => window.screen.width <= MobileMaxWidth;

const Admin: FunctionComponent<IAdmin> = ({}: IAdmin) => {
    const [contractMenu, setContract] = useState(false);
    const [hiddenMenu, setHiddenMenu] = useState(false);
    const url = window.location.href.split('/admin')[1];

    useEffect(() => {
        if (url.includes('/ferramenta-video')) {
            return setHiddenMenu(true);
        }

        setHiddenMenu(false);
    }, [url]);

    useEffect(() => {
        window.addEventListener('resize', () => {
            if (!isMobile()) setContract(false);
            else setContract(true);
        });

        return () => window.removeEventListener('resize', () => {});
    }, []);

    return (
        <>
            {/*  <Menu admin /> */}

            {!hiddenMenu && <DynamicHeader />}

            <AdminProvider>
                <Styled.MenuIcon>
                    <AiOutlineMenu onClick={() => setContract(!contractMenu)} />
                </Styled.MenuIcon>
                <Styled.Container resetPadding={hiddenMenu}>
                    {!hiddenMenu && <AdminBarraLateral contract={contractMenu} />}
                    <AdminContent contractMenu={contractMenu} resetPadding={hiddenMenu} />
                </Styled.Container>
                {ToasterDefault()}
            </AdminProvider>
        </>
    );
};

export default Admin;
